import isObject from './object'

function isArrayOfObjects(val) {
  if (val.length === 0) {
    return false
  }
  return isObject(val[0])
}

export default isArrayOfObjects
